import type { ExtensionLogger, LogSeverity, Location, LogMessage } from '@sap/ux-specification-types';
import { logSeverityLabel } from '@sap/ux-specification-types';

/**
 * Internal representation of one log entry
 */
interface LogEntry {
    severity: LogSeverity;
    message: string;
    location?: Location;
}

/**
 * Function to create a new log entry and add it to the logger.
 * If no logger is passed, puts the message to the console.
 *
 * @param logger - the logger instance
 * @param logEntry - The log entry containing severity, message, and optional location
 * @param meta - option list of strings/objects
 */
export const log = (logger: ExtensionLogger, logEntry: LogEntry, ...meta: LogMessage[]): void => {
    if (logger) {
        if (logEntry.location) {
            logger[logEntry.severity](logEntry.message, { location: logEntry.location, ...meta });
        } else {
            logger[logEntry.severity](logEntry.message, ...meta);
        }
    } else {
        if (logEntry.location) {
            if (logEntry.location.range) {
                console.log(
                    `${logSeverityLabel[logEntry.severity]}: ${logEntry.message}, location: ${
                        logEntry.location.path
                    }, ${logEntry.location.range}`,
                    ...meta
                );
            } else {
                console.log(
                    `${logSeverityLabel[logEntry.severity]}: ${logEntry.message}, location: ${logEntry.location.path}`,
                    ...meta
                );
            }
        } else {
            console.log(`${logSeverityLabel[logEntry.severity]}: ${logEntry.message}`, ...meta);
        }
    }
};
